import { DeskData } from '@/datamodel/deskdata'
import { GameResult } from '@/datamodel/game-result'
import { EventBuss, GAME_TYPE } from '@/utils/constants'
import { Options, Vue } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { BetViewBaseMixin } from './bet-view-mixin'
import PcBaccaratBetView from './d-baccarat-bet-view.vue'
import PcDragonTigerBetView from './d-dragon-tiger-bet-view.vue'
import { Table } from 'vue'

@Options({
    components: {
        PcBaccaratBetView,
        PcDragonTigerBetView
    }
})
export class BetViewMixin extends Vue {
    @Prop({ default: '' })
    gameType!: string
    @Prop({ default: -1 })
    chipValue!: number
    @Prop({ default: false })
    allowBet!: boolean

    @Prop({ default: false })
    s6Mode!: boolean

    $refs!: Vue['refs']
    emitter!: Vue['emitter']

    @Getter('currentDesk') currentDesk!: Table
    @Getter('memberId') memberId!: number

    mounted(): void {
        // console.log(this.gameType, 'ABV')
    }

    resetBet(): void {
        const bettingView = this.$refs['bettingview'] as BetViewBaseMixin
        if (bettingView) {
            bettingView.OnCancelBetTemp()
            bettingView.ResetConfirmedTemp()
        }
    }

    showResult(deskResult: GameResult | undefined): void {
        const bettingView = this.$refs['bettingview'] as BetViewBaseMixin

        if (bettingView) bettingView.showResult(deskResult)
    }

    hideGameResult(): void {
        const bettingView = this.$refs['bettingview'] as BetViewBaseMixin
        if (bettingView) bettingView.hideGameResult()
    }

    redConfirmed = 0
    blueConfirmed = 0
    greenConfirmed = 0
    bluePairConfirmed = 0
    redPairConfirmed = 0
    super6Confirmed = 0
    redSuper6Confimed = 0
    dragonSevenConfirmed = 0
    bearEightConfirmed = 0
    bigTigerConfirmed = 0
    smallTigerConfirmed = 0

    juNo = 0

    @Watch('currentDesk', { deep: true })
    DeskDataChange(): void {
        const bettingView = this.$refs['bettingview'] as BetViewBaseMixin
        if (bettingView) bettingView.ResetConfirmedTemp()

        this.juNo = this.currentDesk?.expand.juNo || 0

        if (this.currentDesk && this.currentDesk.expand.betFormList) {
            // set confirmed bet here

            if (
                this.currentDesk.expand.betFormList &&
                this.currentDesk.expand.betFormList.length > 0
            ) {
                const { betFormList } = this.currentDesk.expand
                let redBet = 0
                let blueBet = 0
                let greenBet = 0
                let redPairBet = 0
                let bluePairBet = 0
                let bankerFree = 0
                let super6 = 0
                let dragon7 = 0
                let bear8 = 0
                let bigTiger = 0
                let smallTiger = 0
                // console.log(betFormList, 'betformlist')

                betFormList.forEach(betInfo => {
                    if (betInfo.memberId === this.memberId) {
                        const { playName, amount } = betInfo

                        if (playName === '庄') {
                            redBet += amount
                        } else if (playName === '庄对') {
                            redPairBet += amount
                        } else if (playName === '闲') {
                            blueBet += amount
                        } else if (playName === '闲对') {
                            bluePairBet += amount
                        } else if (playName === '和') {
                            greenBet += amount
                        } else if (playName === '龙') {
                            redBet += amount
                        } else if (playName === '虎') {
                            blueBet += amount
                        } else if (playName === '超级六') {
                            super6 += amount
                        } else if (playName === '免佣庄') {
                            bankerFree += amount
                        } else if (playName === '龙七') {
                            dragon7 += amount
                        } else if (playName === '熊八') {
                            bear8 += amount
                        } else if (playName === '大老虎') {
                            bigTiger += amount
                        } else if (playName === '小老虎') {
                            smallTiger += amount
                        }
                    }
                })

                this.redConfirmed = redBet
                this.blueConfirmed = blueBet
                this.greenConfirmed = greenBet
                this.redPairConfirmed = redPairBet
                this.bluePairConfirmed = bluePairBet
                this.super6Confirmed = super6
                this.redSuper6Confimed = bankerFree

                this.dragonSevenConfirmed = dragon7
                this.bearEightConfirmed = bear8
                this.bigTigerConfirmed = bigTiger
                this.smallTigerConfirmed = smallTiger

                // const s6 = this.redSuper6Confimed + this.super6Confirmed
                // if (s6 > 0) {
                //     this.emitter.emit(EventBuss.TOGGLE_SMODE, true)
                //     this.emitter.emit(EventBuss.LOCKED_SMODE, true)
                //     return
                // }

                // this.redConfirmed = 100
                // console.log('SET CONFIRMED BETS', this.redConfirmed)

                // console.log('SET CONFIRMED BETS', this.redConfirmed)

                // const redTotalConfirmedAndRedFree =
                //     bankerFree + this.redConfirmed
                // if (redTotalConfirmedAndRedFree > 0) {
                //     console.log('TOGGLE_SMODE', false)
                //     this.emitter.emit(EventBuss.TOGGLE_SMODE, false)
                //     this.emitter.emit(EventBuss.LOCKED_SMODE, false)
                // }
                const allToatalConfirmedBets =
                    redBet +
                    blueBet +
                    greenBet +
                    redPairBet +
                    bluePairBet +
                    super6 +
                    bankerFree +
                    dragon7 +
                    bear8 +
                    bigTiger +
                    smallTiger
                if (allToatalConfirmedBets > 0) {
                    this.emitter.emit(EventBuss.LOCKED_SMODE, true)

                    if (bankerFree > 0) {
                        this.emitter.emit(EventBuss.TOGGLE_SMODE, true)
                    } else if (redBet > 0) {
                        this.emitter.emit(EventBuss.TOGGLE_SMODE, false)
                    }
                }
            } else {
                this.redConfirmed = 0
                this.blueConfirmed = 0
                this.greenConfirmed = 0
                this.redPairConfirmed = 0
                this.bluePairConfirmed = 0
                this.super6Confirmed = 0
                this.redSuper6Confimed = 0
                this.dragonSevenConfirmed = 0
                this.bearEightConfirmed = 0
                this.bigTigerConfirmed = 0
                this.smallTigerConfirmed = 0

                this.emitter.emit(EventBuss.LOCKED_SMODE, false)

                // console.log('SET CONFIRMED BETS', 'NONE')
            }
        }
    }
}
